// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:48:15

export default {
  "id": "nuts-stack-sort-nuts-and-bolts",
  "slug": "nuts-stack-sort-nuts-and-bolts",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6d037e3e7ac9405785f133af7b1001c9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6d037e3e7ac9405785f133af7b1001c9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Nuts Stack Sort: Nuts & Bolts",
      "description": "Challenging yet relaxing Nuts & Bolts sort puzzle with a unique twist!\n\nNuts Stack Sort: Nuts & Bolts is a fun and addictive stack sort puzzle game with a unique twist! Strategically sort and match three same color nuts based on box color in this jam puzzles. Every level offers an exciting challenge in this addictive sort colors puzzle game. Test yourself with this amazing brain teaser!",
      "instructions": "Easy tap and match mechanic. Tap and sort nuts according to box color.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "坚果堆叠排序：坚果与螺栓",
      "description": "具有挑战性但令人放松的Nuts & Bolts排序谜题，带有独特的变体！\n\nNuts Stack Sort：Nuts & Bolts是一款有趣且上瘾的排序谜题游戏，带有独特的变体！在这个热闹的谜题中，根据箱子颜色战略性地排序和匹配三个相同颜色的螺母。每个关卡都提供了这个上瘾的排序颜色谜题游戏中的激动人心的挑战。用这个惊人的脑力游戏来测试自己吧！",
      "instructions": "简单点击匹配机制。点击将坚果按照箱子颜色分类。",
      "genres": [
        "谜题"
      ],
      "tags": [
        "排序"
      ]
    },
    "zh-TW": {
      "title": "核桃堆疊排序：核桃與螺釘",
      "description": "挑戰性與放鬆並存的 Nuts & Bolts 排序拼圖遊戲，帶有獨特的變化！\n\nNuts Stack Sort：Nuts & Bolts 是一款有趣且上癮的堆疊排序拼圖遊戲，帶有獨特的變化！在這些擁有夾心的拼圖中，策略性地將三顆同色系的螺母根據箱子顏色進行排序和匹配。每個關卡都為這款上癮的排序顏色拼圖遊戲帶來刺激的挑戰。用這個驚人的腦筋急轉彎遊戲來測試自己吧！",
      "instructions": "簡單點擊匹配機制。點擊並將果仁按照箱子的顏色分類。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "排序"
      ]
    },
    "zh-HK": {
      "title": "花生堆疊排序：花生同螺絲",
      "description": "挑戰性兼放鬆的Nuts & Bolts排序益智遊戲，獨特轉折！\n\nNuts Stack Sort：Nuts & Bolts是一款充滿樂趣及上癮的堆疊排序益智遊戲，具有獨特風格！在這些夾雜的謎題中，依據盒子顏色策略性地排序和匹配三顆同色顆螺母。每個關卡都提供一個令人興奮的挑戰，這是一款令人上癮的排序顏色益智遊戲。用這個出色的腦筋急轉彎遊戲挑戰自己！",
      "instructions": "簡易點擊配對機制。點擊並按照箱色分類坚果。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "排序"
      ]
    },
    "ja": {
      "title": "ナッツスタックソート: ナッツとボルト",
      "description": "挑戦的でリラックスできるユニークな仕掛けのNuts & Boltsの並べ替えパズル！\n\nNuts Stack Sort：Nuts & Boltsは、ユニークな仕掛けを持つ楽しい魅力的な並べ替えパズルゲームです。ボックスの色に基づいて、色が同じ3つのナットを戦略的に並べ替え、一致させましょう。このパズルには、レベルごとに魅力的な挑戦が用意されています。この素晴らしい脳トレで自分自身を試してみてください！",
      "instructions": "簡単なタップと一致させるメカニクス。タップしてボックスの色に応じてナツを並べる。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "並べ替え"
      ]
    },
    "ko": {
      "title": "坚果堆叠排序：坚果与螺栓",
      "description": "挑戦的이지만 편안한 Nuts & Bolts 정렬 퍼즐이 특별한 돌파구를 가지고 있습니다!\n\nNuts Stack Sort: Nuts & Bolts는 독특한 돌파구를 가진 재미있고 중독성이 있는 스택 정렬 퍼즐 게임입니다! 이 맥주 퍼즐에서 상자의 색상에 따라 세 가지 색상의 나무 막대기를 전략적으로 정렬하고 일치시켜주세요. 각 레벨마다 중독성이 있는 색상 정렬 퍼즐 게임에서 흥미로운 도전이 제공됩니다. 이 놀라운 뇌력 테스트로 자신을 테스트해보세요!",
      "instructions": "쉬운 탭과 매칭 메커닉. 상자의 색상에 따라 가루를 탭하여 정리하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "정렬"
      ]
    },
    "fr": {
      "title": "Nuts Stack Sort : Noix & Boulons",
      "description": "Défiant mais relaxant, Nuts & Bolts est un puzzle de tri des piles avec un tour unique !\n\nNuts Stack Sort : Nuts & Bolts est un jeu de puzzle de tri des piles amusant et accrocheur avec un tour unique ! Triagez et associez stratégiquement trois noix de la même couleur en fonction de la couleur de la boîte dans ces puzzles en désordre. Chaque niveau offre un défi captivant dans ce jeu de puzzle de tri des couleurs accrocheur. Testez-vous avec ce défi intellectuel incroyable !",
      "instructions": "Mécanique simple de tap et association. Tapez et classez les noix selon la couleur de la boîte.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "Tri"
      ]
    }
  }
};
